import apiClient from './axios';

export const usersApi = {
  // === Функції для адміністратора ===
  
  // Отримати всіх користувачів (без пагінації - для сумісності)
  getAllUsers: () => {
    return apiClient.get('/admin/users');
  },

  // Отримати користувачів з пагінацією
  getAllUsersPaginated: (params = {}) => {
    return apiClient.get('/admin/users/paginated', { params });
  },
  
  // Отримати зареєстрованих користувачів
  getRegisteredUsers: () => {
    return apiClient.get('/admin/users/registered');
  },
  
  // Отримати користувачів за департаментом  
  getUsersByDepartment: (departmentId) => {
    return apiClient.get(`/admin/users/department/${departmentId}`);
  },
  
  // Отримати деталі користувача
  getUserDetails: (id) => {
    return apiClient.get(`/admin/users/${id}`);
  },
  
  // Альтернативний метод для сумісності
  getUserById: (id) => {
    return apiClient.get(`/admin/users/${id}`);
  },
  
  // Створити користувача
  createUser: (userData) => {
    return apiClient.post('/admin/users', userData);
  },
  
  // Оновити дані користувача
  updateUser: (id, userData) => {
    return apiClient.put(`/admin/users/${id}`, userData);
  },
  
  // Видалити користувача
  deleteUser: (id) => {
    return apiClient.delete(`/admin/users/${id}`);
  },
  
  // Активувати користувача
  activateUser: (id) => {
    return apiClient.post(`/admin/users/${id}/activate`);
  },
  
  // Деактивувати користувача
  deactivateUser: (id) => {
    return apiClient.post(`/admin/users/${id}/deactivate`);
  },
  
  // Призначити роль адміністратора
  assignAdminRole: (id) => {
    return apiClient.post(`/admin/users/${id}/assign-admin`);
  },
  
  // Альтернативний метод для сумісності
  makeUserAdmin: (id) => {
    return apiClient.post(`/admin/users/${id}/assign-admin`);
  },
  
  // Зняти роль адміністратора
  removeAdminRole: (id) => {
    return apiClient.post(`/admin/users/${id}/remove-admin`);
  },
  
  // Імпорт користувачів з CSV
  importUsers: (fileData) => {
    return apiClient.post('/admin/users/import', fileData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  // Отримати статистику користувачів
  getUserStats: () => {
    return apiClient.get('/admin/users/stats');
  },
  
  // === Функції для звичайних користувачів ===
  
  // Отримати профіль поточного користувача
  getCurrentUserProfile: () => {
    return apiClient.get('/profile');
  },
  
  // Альтернативний шлях для отримання профілю (для сумісності)
  getCurrentUserProfileAlt: () => {
    return apiClient.get('/users/profile');
  },
  
  // Отримати інформацію про поточного користувача
  getCurrentUser: () => {
    return apiClient.get('/users/me');
  },
  
  // Оновити профіль поточного користувача (основний ендпоінт)
  updateCurrentUserProfile: (profileData) => {
    return apiClient.put('/profile', profileData);
  },
  
  // Альтернативний метод оновлення через /users/me
  updateCurrentUser: (profileData) => {
    return apiClient.put('/users/me', profileData);
  },
  
  // Пошук користувачів
  searchUsers: (query, departmentId, isRegistered, isUnionMember) => {
    const params = new URLSearchParams();
    if (query) params.append('query', query);
    if (departmentId) params.append('departmentId', departmentId);
    if (isRegistered !== undefined) params.append('isRegistered', isRegistered);
    if (isUnionMember !== undefined) params.append('isUnionMember', isUnionMember);
    
    return apiClient.get(`/users/search?${params.toString()}`);
  },
  
  // Отримати історію використання знижок користувача (без пагінації - для сумісності)
  getUserUsageHistory: (userId) => {
    return apiClient.get(`/usages/user/${userId}`);
  },

  // Отримати історію використання з пагінацією
  getUserUsageHistoryPaginated: (userId, params = {}) => {
    return apiClient.get(`/usages/user/${userId}/paginated`, { params });
  },
  
  // Отримати доступні знижки для користувача
  getUserAvailableDiscounts: () => {
    return apiClient.get('/discounts');
  },
  
  // Отримати статистику заощаджень користувача
  getUserSavings: (userId) => {
    return apiClient.get(`/usages/user/${userId}/savings`);
  },

  // === Масові операції ===

  // Зробити всіх користувачів членами профспілки
  makeAllUnionMembers: () => {
    return apiClient.post('/admin/users/bulk/make-union-members');
  },

  // Активувати всіх користувачів
  activateAllUsers: () => {
    return apiClient.post('/admin/users/bulk/activate-all');
  },

  // Видалити всіх користувачів окрім адмінів
  deleteAllNonAdmins: () => {
    return apiClient.delete('/admin/users/bulk/delete-non-admins', {
      params: {
        confirm: 'DELETE_ALL_NON_ADMINS',
      },
    });
  }
};

// Експортуємо за замовчуванням для підтримки обох варіантів імпорту
export default usersApi;